import React from 'react';

// import components. In same order as they appear on Dato Ingerior Page Template
import AccordionBuilder from 'helpers/builders/accordion-builder';
// Button Link. Uses StandardContent component
import CalendarBuilder from 'helpers/builders/calendar-builder';
import CallToActionBuilder from 'helpers/builders/call-to-action-builder';
import CardsWithDescriptionsCollectionBuilder from 'helpers/builders/cards-with-descriptions-collection-builder';
import CardsWithLabelsCollectionBuilder from 'helpers/builders/cards-with-labels-collection-builder';
import CountdownSliderBuilder from 'helpers/builders/countdown-slider-builder';
import FeaturedEventsBuilder from 'helpers/builders/featured-events-builder';
import FeaturedImageBuilder from 'helpers/builders/featured-image-builder';
import FeaturedVideoLargeBuilder from 'helpers/builders/featured-video-large-builder';
import ImageCardCarouselBuilder from 'helpers/builders/image-card-carousel-builder';
import ImageContentRowCollectionBuilder from 'helpers/builders/image-content-row-collection-builder';
import ImageGalleryBuilder from 'helpers/builders/image-gallery-builder';
import LinkListCardsCollectionBuilder from 'helpers/builders/link-list-cards-collection-builder';
import NewsletterCtaBuilder from 'helpers/builders/newsletter-cta-builder';
import ServicesRowBuilder from 'helpers/builders/services-row-builder';
import SponsorsCarouselBuilder from 'helpers/builders/sponsors-carousel-builder';
import StandardContent from 'components/partials/standard-content';
import TableBuilder from 'helpers/builders/table-builder';
import TypeformBuilder from 'helpers/builders/typeform-builder';
import VideoCardsRowBuilder from 'helpers/builders/video-cards-row-builder';

// Import types
import { ContentBlocks } from 'types/content-blocks';

const ContentBlocksBuilder: React.FC<{ contentBlocks?: ContentBlocks }> = ({ contentBlocks }) => {

    if (!contentBlocks) return null;

    return (
        <>
            {contentBlocks?.map((contentBlock, index) => {
                if (typeof contentBlock === 'object' && contentBlock !== null && '__typename' in contentBlock) {

                    if (contentBlock.__typename === 'DatoCmsStandardContentRichText' && contentBlock.content !== null) {

                        return <StandardContent key={index} content={contentBlock.content} />;

                    } else if (contentBlock.__typename === 'DatoCmsAccordion') {

                        return <AccordionBuilder key={index} accordionData={contentBlock} />;

                    } else if (contentBlock.__typename === 'DatoCmsCallToAction') {

                        return <CallToActionBuilder key={index} callToActionData={contentBlock} />;

                    } else if (contentBlock.__typename === 'DatoCmsCardsWithDescriptionsCollection') {

                        return <CardsWithDescriptionsCollectionBuilder key={index} cardsWithDescriptionsCollectionData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsCardsWithLabelsCollection") {

                        return <CardsWithLabelsCollectionBuilder key={index} cardsWithLabelsCollectionData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsCountdownSlider") {

                        return <CountdownSliderBuilder key={index} countdownSliderData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsFeaturedEventsBlock") {

                        return <FeaturedEventsBuilder key={index} featuredEventsBlockData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsFeaturedImage") {

                        return <FeaturedImageBuilder key={index} featuredImageData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsFeaturedVideoLarge") {

                        return <FeaturedVideoLargeBuilder key={index} featuredVideoLargeData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsImageContentRowCollection") {

                        return <ImageContentRowCollectionBuilder key={index} imageContentRowCollection={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsImageGallery") {

                        return <ImageGalleryBuilder key={index} imageGalleryData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsNewsletterCta") {

                        return <NewsletterCtaBuilder key={index} newsletterCtaData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsServicesRow") {

                        return <ServicesRowBuilder key={index} servicesRowData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsSponsorsCarousel") {

                        return <SponsorsCarouselBuilder key={index} sponsorsCarouselData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsTable") {

                        return <TableBuilder key={index} tableData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsTypeform") {

                        return <TypeformBuilder key={index} typeformData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsVideoCardsRow") {

                        return <VideoCardsRowBuilder key={index} videoCardsRowData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsLink") {

                        return <StandardContent key={index} link={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsLinkListCardsCollection") {

                        return <LinkListCardsCollectionBuilder key={index} linkListCardsCollectionData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsCalendarGraphic") {

                        return <CalendarBuilder key={index} calendarData={contentBlock} />;

                    } else if (contentBlock.__typename === "DatoCmsImageCardCarousel") {

                        return <ImageCardCarouselBuilder key={index} imageCardCarouselData={contentBlock} />;

                    } else {

                        return (
                            <div key={index}>
                                <h2>{contentBlock.__typename}</h2>
                                <pre>{JSON.stringify(contentBlock, null, 2)}</pre>
                            </div>
                        );
                    }
                }
                return null;
            })}
        </>
    );
};

export default ContentBlocksBuilder;
